import axios from "axios";

export const getErpData = (id, clients, collaborators) => {
  const requestUrl = `/team/erp-data`;
  let params = {
    organizationId: id,
    clients: clients.map(({ value }) => value),
    collaborators: collaborators.map(({ value }) => value)
  };

  return axios.get(requestUrl, {
    params
  });
};



// WEBPACK FOOTER //
// ./src/api/erp-data.js